import { render, staticRenderFns } from "./TransferFunds.vue?vue&type=template&id=0ec75f53&scoped=true&"
import script from "./TransferFunds.vue?vue&type=script&lang=js&"
export * from "./TransferFunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec75f53",
  null
  
)

export default component.exports